export default __webpack_public_path__ + "3092c45fac3122e7bf3fdcbc40926dea.svg";